export type CategoryKey = "film" | "music" | "lifestyle" | "brand";

export interface Category {
  key: CategoryKey;
  name: string;
  path: string;
  icon: string;
  tagline: string;
  description: string;
  subTypes: string[];
}

export interface NewsItem {
  id: string;
  title: string;
  subtitle: string;
  categoryKey: CategoryKey;
  categoryName: string;
  subType: string;
  cover: string;
  summary: string;
  content: string[];
  author: string;
  publishDate: string;
  views: number;
  tags: string[];
  featured: boolean;
}

export const categories: Category[] = [
  {
    key: "film",
    name: "影视",
    path: "/category/film",
    icon: "ri-movie-2-line",
    tagline: "银幕内外，热点追踪",
    description: "聚焦院线新片、热播剧集与综艺动态，第一时间为你梳理值得一看的影视内容。",
    subTypes: ["电影", "电视剧", "综艺"],
  },
  {
    key: "music",
    name: "音乐",
    path: "/category/music",
    icon: "ri-music-2-line",
    tagline: "旋律风向，一周上新",
    description: "从流行到民谣，从说唱到电子，精选本周最值得循环的歌单与音乐现场。",
    subTypes: ["流行", "摇滚", "民谣", "电子", "说唱"],
  },
  {
    key: "lifestyle",
    name: "生活方式",
    path: "/category/lifestyle",
    icon: "ri-leaf-line",
    tagline: "把日子过成喜欢的样子",
    description: "美食、旅行、家居与时尚，一起发现藏在日常里的松弛感与新鲜感。",
    subTypes: ["美食", "旅行", "家居", "时尚", "健身"],
  },
  {
    key: "brand",
    name: "品牌",
    path: "/category/brand",
    icon: "ri-store-2-line",
    tagline: "小蜜桃的品牌朋友圈",
    description: "记录小蜜桃的品牌故事、合作案例与新品动态，看看我们和谁一起玩。",
    subTypes: ["品牌故事", "合作案例", "新品发布"],
  },
];

export function getCategoryByKey(key: string): Category | undefined {
  return categories.find((item) => item.key === key);
}